const MINUTE = 60;

const DURATION = {
  STANDARD: 'STANDARD',
  LONGFORM_SHORT: 'LONGFORM_SHORT',
  LONGFORM_MEDIUM: 'LONGFORM_MEDIUM',
  LONGFORM_LONG: 'LONGFORM_LONG'
};

const getDefaultDuration = (clips) => {
  const totalDuration = clips.reduce(
    (total, { duration }) => total + !Number.isNaN(duration) ? duration : 0,
    0);

  if (totalDuration > 20 * MINUTE) {
    return DURATION.LONGFORM_LONG;
  }

  if (totalDuration > 10 * MINUTE) {
    return DURATION.LONGFORM_MEDIUM;
  }

  if (totalDuration > 5 * MINUTE) {
    return DURATION.LONGFORM_SHORT;
  }

  return DURATION.STANDARD;
};

export default getDefaultDuration;